import { Reducer } from 'redux'
import { IMarketplaceStore } from '../types'
import {
  LANE_MODAL_ACTION_TYPES as m,
  ROUTING_GUIDE_ACTION_TYPES as c,
  ROUTING_GUIDE_COUNT_ACTION_TYPES as d,
} from './actions'
import * as Types from './types'

const defaultCountValues: Types.IRoutingGuideCounts = {
  reservedCount: 0,
}

const initState = {
  data: undefined,
  loading: false,
  countLoading: false,
  error: '',
  counts: defaultCountValues,
  showEditModal: false,
}

interface IRoutingGuideModalAction {
  type: m.LANE_MODAL_OPEN | m.LANE_MODAL_CLOSE
}

interface IRoutingGuideResponsePayload {
  laneMetrics: Types.ILaneMetric[]
  specificLane: Types.ISpecificLane
}
interface IRoutingGuideCountResponsePayload {
  reservedCount: number
}

interface IRoutingGuideRequest {
  type: c.FETCH_ROUTING_GUIDE_REQUEST
  payload: IRoutingGuideResponsePayload
}

interface IRoutingGuideSuccess {
  type: c.FETCH_ROUTING_GUIDE_SUCCESS
  payload: IRoutingGuideResponsePayload
}

interface IRoutingGuideFailure {
  type: c.FETCH_ROUTING_GUIDE_FAILURE
  error: string
  payload: IRoutingGuideResponsePayload
}

interface IRoutingGuideCountRequest {
  type: d.FETCH_ROUTING_GUIDE_COUNT_REQUEST
  payload: IRoutingGuideCountResponsePayload
}

interface IRoutingGuideCountSuccess {
  type: d.FETCH_ROUTING_GUIDE_COUNT_SUCCESS
  payload: IRoutingGuideCountResponsePayload
}

interface IRoutingGuideCountFailure {
  type: d.FETCH_ROUTING_GUIDE_COUNT_FAILURE
  error: string
  payload: IRoutingGuideCountResponsePayload
}

type RoutingGuideActions =
  | IRoutingGuideRequest
  | IRoutingGuideSuccess
  | IRoutingGuideFailure
  | IRoutingGuideCountRequest
  | IRoutingGuideCountSuccess
  | IRoutingGuideCountFailure
  | IRoutingGuideModalAction

/** Reducer */
const routingGuideReducer: Reducer<Types.IRoutingGuideState, RoutingGuideActions> = (
  state: Types.IRoutingGuideState = initState,
  action: RoutingGuideActions
): Types.IRoutingGuideState => {
  switch (action.type) {
    case c.FETCH_ROUTING_GUIDE_REQUEST: {
      return {
        ...state,
        loading: true,
        data: undefined,
      }
    }
    case c.FETCH_ROUTING_GUIDE_SUCCESS: {
      const {
        payload: { laneMetrics, specificLane },
      } = action as IRoutingGuideSuccess
      return {
        ...state,
        loading: false,
        data: {
          laneMetrics,
          specificLane,
        },
      }
    }
    case c.FETCH_ROUTING_GUIDE_FAILURE: {
      const { error } = action as IRoutingGuideFailure
      return {
        ...state,
        loading: false,
        data: undefined,
        error,
      }
    }
    case d.FETCH_ROUTING_GUIDE_COUNT_REQUEST: {
      return {
        ...state,
        countLoading: true,
        counts: defaultCountValues,
      }
    }
    case d.FETCH_ROUTING_GUIDE_COUNT_SUCCESS: {
      const {
        payload: { reservedCount },
      } = action as IRoutingGuideCountSuccess
      return {
        ...state,
        countLoading: false,
        counts: {
          reservedCount,
        },
      }
    }
    case d.FETCH_ROUTING_GUIDE_COUNT_FAILURE: {
      const { error } = action as IRoutingGuideCountFailure
      return {
        ...state,
        countLoading: false,
        counts: defaultCountValues,
        error,
      }
    }

    case m.LANE_MODAL_OPEN: {
      return {
        ...state,
        showEditModal: true,
      }
    }

    case m.LANE_MODAL_CLOSE: {
      return {
        ...state,
        showEditModal: false,
      }
    }

    default:
      return state
  }
}

export default routingGuideReducer

/** Selectors */
export const selectRoutingGuide = (state: IMarketplaceStore): Types.IRoutingGuide | undefined =>
  state.routingGuide.data

export const selectRoutingGuideRequestStatus = (state: IMarketplaceStore): boolean =>
  state.routingGuide.loading

export const selectRoutingGuideCounts = (state: IMarketplaceStore): Types.IRoutingGuideCounts =>
  state.routingGuide.counts || defaultCountValues
